<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Solicitações</h5>
                <hr />
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-2">
                        <label>Período</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
                        :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>				
                    </div> 
                    <div class="p-field p-col-12 p-md-5">
                        <label>Empresa</label>
                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" 
                            optionValue="id" placeholder="Selecione" @change="listarCentrosCustos"/>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label>Centro de custo</label>
                        <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" 
                            optionValue="id" dataKey="id" placeholder="Todos"/>
                    </div> 
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="atualizarPorFiltro"/>
                    </div>                                 
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">                           
                        <div class="p-field-radiobutton">
                            <RadioButton v-model="statusItem" value="Pendente" name="grupoStatus"/>
                            <label class="p-mr-2">Pendente</label>
                            <RadioButton v-model="statusItem" value="Não Aprovado" name="grupoStatus"/>
                            <label class="p-mr-2">Não Aprovado</label>
                            <RadioButton v-model="statusItem" value="Aprovado" name="grupoStatus"/>
                            <label>Aprovado</label>
                        </div>
                    </div>                    
                    <div class="p-field p-col-12 p-md-5">
                        <div class="p-inputgroup">
                            <InputText v-model.trim="crachaPisNome" 
                            @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                            @keyup.enter="atualizarPorFiltro" 
                            placeholder="crachá/pis/cpf/nome"/>
                            <Button icon="pi pi-search" title="Pesquisar" @click="atualizarPorFiltro"/>                    
                        </div>
                    </div>                                
                </div>
                <DataTable :value="solicitacoes" rowGroupMode="subheader" groupRowsBy="funcionario.nomecc" sortMode="single"
                    sortField="funcionario.nome" :sortOrder="1" responsiveLayout="scroll" :expandableRowGroups="true"
                    :expandedRowGroups.sync="expandedRowGroups" class="p-datatable-sm">
                    <Column field="" header="Funcionário"></Column>
                    <Column field="data" header="Data da Solicitação"></Column>
                    <Column field="dataPonto" header="Data do Ponto"></Column>
                    <Column field="tipo" header="Tipo da Solicitação"></Column>
                    <Column field="status" header="Status">
                        <template #body="slotProps">
                            <span class="p-text-bold" :class="aplicarBadgeStatus(slotProps.data.status)">{{
                                slotProps.data.status }}</span>
                        </template>
                    </Column>
                    <Column field="usuarioAprovacao" header="Ação Realizada por"></Column>                  
                    <Column>
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2"
                                @click="exibirModalItemSolicitacao(slotProps.data)" />
                        </template>
                    </Column>
                    <template #groupheader="slotProps">
                        <span class="p-text-bold">{{
                            slotProps.data.funcionario.nomecc
                        }}</span>
                    </template>
                </DataTable>
                <Paginacao ref="paginacao" :qtdLinhasPorPagina="[20,25,30]" :callback="atualizarPorPagina"/>
            </div>
            <solicitacao-justificar ref="solicitacaoJustificar" :callback="atualizarPeriodoEditado" />
            <solicitacao-folga ref="solicitacaoFolga" :callback="atualizarPeriodoEditado" />
            <solicitacao-mudanca-horario ref="solicitacaoMudancaHorario" :callback="atualizarPeriodoEditado" />
            <solicitacao-ocorrencia ref="solicitacaoOcorrencia" :callback="atualizarPeriodoEditado" />
            <solicitacao-ajuste-parcial ref="solicitacaoAjusteParcial" :callback="atualizarPeriodoEditado" />
            <solicitacao-editar-marcacoes ref="solicitacaoEditarMarcacoes" :callback="atualizarPeriodoEditado" />
        </div>        
    </div>
</template>

<script>
import SolicitacaoService from "@/service/SolicitacaoService.js";
import ControlePontoService from "@/service/ControlePontoService";
import CentroCustoService from '@/service/CentroCustoService';
import SolicitacaoJustificar from "@/components/pages/movimento/solicitacoes/SolicitacaoJustificar.vue";
import SolicitacaoFolga from "@/components/pages/movimento/solicitacoes/SolicitacaoFolga.vue";
import SolicitacaoMudancaHorario from "@/components/pages/movimento/solicitacoes/SolicitacaoMudancaHorario.vue";
import SolicitacaoOcorrencia from "@/components/pages/movimento/solicitacoes/SolicitacaoOcorrencia.vue";
import SolicitacaoAjusteParcial from "@/components/pages/movimento/solicitacoes/SolicitacaoAjusteParcial.vue";
import SolicitacaoEditarMarcacoes from "@/components/pages/movimento/solicitacoes/SolicitacaoEditarMarcacoes.vue";
import Paginacao from '@/components/template/Paginacao.vue';
import { mapGetters, mapActions } from "vuex";
import { localeCalendarBR, exibirMensagem, exibirMensagemSis, clonar } from "@/global";

export default {   
    controlePontoService: null,
    centroCustoService: null,
    solicitacaoService: null,
    data() {
        return {
            mesAno: new Date(),
            rangeData: "",
            expandedRowGroups: [],
            cnpjs: [],
            centrosCustos: [],
            idCnpjSelecionado: null,
            idCentroCustoSelecionado: null,
            crachaPisNome: null,
            localeCalendarBR: localeCalendarBR,
            solicitacoes: [],
            solicitacaoSelecionada: null,
            statusItem: 'Pendente',
            filtro: {},
            qtdLinhasPorPagina: 20,
            numPagina: 1,
            permissaoEditar: false
        };
    },
    methods: {
        ...mapGetters("sessao", ["getDadosRequisicao", "getPermissoes", 'getCacheEmpresa']),
        ...mapActions('sessao', ['atualizarCacheEmpresa']),
        /**
         * 
         * @param {*} paginacao 
         */
         atualizarPorPagina(paginacao) {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            this.numPagina = paginacao.pagina;
            this.qtdLinhasPorPagina = paginacao.linhas;      
            this.listar();      
        },
        /**
         * 
         */
        atualizarPorFiltro() {
            this.numPagina = 1;
            this.$refs.paginacao.paginar(1);
        },       
        /**
         *
         */
        listar() {            
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else { 
                if(this.idCentroCustoSelecionado == null) {
                    this.centrosCustos.forEach(ct => {
                        if(ct.id != null) {
                            idsCentrosCustos.push(ct.id);
                        }
                    });
                } else {
                    idsCentrosCustos.push(this.idCentroCustoSelecionado);                    
                    this.filtrarCentosCustosFilhos(
                        this.idCentroCustoSelecionado, 
                        this.centrosCustos, idsCentrosCustos
                    );                   
                }                
            }
            this.solicitacoes = [];
            this.expandedRowGroups = [];
            let requisicao = {
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
                solicitacaoRequisicao: {
                    idCnpj: this.idCnpjSelecionado,
                    idsCentrosCustos: idsCentrosCustos,
                    nomeOuDocumento: this.crachaPisNome,
                    linhasPorPagina: this.qtdLinhasPorPagina,
                    pagina: this.numPagina,
                    strStatus: this.statusItem
                },                
                usuarioRequisicao: { ...this.getDadosRequisicao() },
            };
            this.solicitacaoService
                .listar(requisicao)
                .then((resp) => {
                    resp.data.solicitacoes.forEach((sol) => {
                        sol.funcionario["nomecc"] =
                            sol.funcionario.nome + " | " + sol.funcionario.centroCusto.nome;
                        sol.data = this.formartarStrData(sol.data, "BR");
                        sol.dataPonto = this.formartarStrData(sol.dataPonto, "BR");
                        if (!sol.observacao) {
                            sol["observacao"] = "";
                        }            
                        if(!sol.usuarioAprovacao) {
                            sol['usuarioAprovacao'] = '';
                        }
                        this.solicitacoes.push(sol);
                    });
                    this.solicitacoes.forEach((sol) => {
                        this.expandedRowGroups.push(sol);
                    });
                    this.$refs.paginacao.atualizar(resp.data.total);
                })
                .catch((erro) => {
                    exibirMensagem(this, erro);
                });
        },           
        /**
         *
         */
        exibirModalItemSolicitacao(solicitacao) {
            this.solicitacaoSelecionada = solicitacao;
            const origem = solicitacao.origem;
            const dados = this.configurarRequisicao(solicitacao);
            if (origem === "CTRL_JUSTIFICAR") {
                this.$refs.solicitacaoJustificar.processar(dados);
            } else if (origem.includes("FOLGA")) {
                this.$refs.solicitacaoFolga.processar(dados);
            } else if (origem.includes("MUDANCA_HORARIO")) {
                this.$refs.solicitacaoMudancaHorario.processar(dados);
            } else if (origem.includes("OCORRENCIA")) {
                this.$refs.solicitacaoOcorrencia.processar(dados);
            } else if (origem === "CTRL_AJUSTE_PARCIAL") {
                this.$refs.solicitacaoAjusteParcial.processar(dados);
            } else if (origem === "CTRL_EDITAR_MARCACAO") {
                this.$refs.solicitacaoEditarMarcacoes.processar(dados);
            }
        },
        /**
         *
         */
        configurarRequisicao(solicitacao) {
            let dados = {};
            let cnpjSelecionado = null;
            this.cnpjs.forEach((cnpj) => {
                if (cnpj.id == this.idCnpjSelecionado) {
                    cnpjSelecionado = cnpj;
                }
            });
            dados["requisicao"] = {};
            dados['permissaoEditar'] = this.permissaoEditar;
            dados.requisicao["mes"] = this.mesAno.getMonth() + 1;
            dados.requisicao["ano"] = this.mesAno.getFullYear();
            dados.requisicao["dataInicio"] = this.formartarStrData(
                solicitacao.dataPonto,
                "US"
            );
            dados.requisicao["dataFinal"] = this.formartarStrData(
                solicitacao.dataPonto,
                "US"
            );
            dados.requisicao["cnpj"] = clonar(cnpjSelecionado);
            dados.requisicao["usuarioRequisicao"] = this.getDadosRequisicao();
            dados["solicitacao"] = clonar(solicitacao);
            return dados;
        },       
        /**
         *
         */
        atualizarPeriodoEditado(solicitacao) {
            this.solicitacaoSelecionada.status = solicitacao.status;
            this.solicitacaoSelecionada.observacao = solicitacao.observacao;
            this.solicitacaoSelecionada.usuarioAprovacao = solicitacao.usuarioAprovacao;
            if (solicitacao.status == "Aprovado") {
                let cnpjSelecionado = null;
                this.cnpjs.forEach((cnpj) => {
                    if (cnpj.id == this.idCnpjSelecionado) {
                        cnpjSelecionado = cnpj;
                    }
                });
                let requisicao = {
                    mes: this.mesAno.getMonth() + 1,
                    ano: this.mesAno.getFullYear(),
                    dataInicio: this.formartarStrData(this.solicitacaoSelecionada.dataPonto, "US"),
                    dataFinal: this.formartarStrData(this.solicitacaoSelecionada.dataPonto, "US"),
                    cnpj: cnpjSelecionado,
                    funcionario: this.solicitacaoSelecionada.funcionario,
                    usuarioRequisicao: { ...this.getDadosRequisicao() },
                };
                this.solicitacaoSelecionada = null;
                this.controlePontoService
                .atualizarPeriodoEditado(requisicao)
                .catch((erro) => {
                    exibirMensagem(this, erro);
                });
            }
        },
        /**
         *
         */
        listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            this.centrosCustos.push({ nome: 'Todos', id: null });
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         *
         */
        listarCentrosCustos() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado;
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: { ...this.getDadosRequisicao() },
            };
            this.centroCustoService
            .listarCentrosCustosUsuario(requisicao)
            .then((resp) => {
                // Cache dados      
                cacheEmpresa.centrosCustos = [];              
                resp.data.forEach(ct => {
                    cacheEmpresa.centrosCustos.push({...ct});
                }); 
                this.idContratoSelecionado = null;                     
                this.centrosCustos = [];                        
                this.centrosCustos.push({ nome: 'Todos', id: null });
                Array.prototype.push.apply(this.centrosCustos, resp.data);
                this.atualizarCacheEmpresa(cacheEmpresa); 
            })
            .catch((erro) => {
                exibirMensagem(this, erro);
            });
        },
         /**
         * 
         * @param {*} idCentroCustoPrincipal 
         * @param {*} centrosCustos 
         * @param {*} idsCentrosCustos 
         */
         filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {            
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },        
        /**
         *
         * @param {*} strData
         * @param {*} formato
         */
        formartarStrData(strData, formato) {
            if (formato == "BR") {
                let partes = strData.split("-");
                return partes[2] + "/" + partes[1] + "/" + partes[0];
            }
            let partes = strData.split("/");
            return partes[2] + "-" + partes[1] + "-" + partes[0];
        },
        /**
         *
         * @param {*} status
         */
        aplicarBadgeStatus(status) {
            let badge = "ik-badge-success";
            if (status == "Pendente") {
                badge = "ik-badge-warnning";
            } else if (status == "Não Aprovado") {
                badge = "ik-badge-danger";
            }
            return badge;
        },
        /**
         *
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();
            this.rangeData = anoAtual - 10 + ":" + (anoAtual + 20);
        },
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoEditar = permissoes.includes(166);			
		}
    },
    components: {
        "solicitacao-justificar": SolicitacaoJustificar,
        "solicitacao-folga": SolicitacaoFolga,
        "solicitacao-mudanca-horario": SolicitacaoMudancaHorario,
        "solicitacao-ocorrencia": SolicitacaoOcorrencia,
        "solicitacao-ajuste-parcial": SolicitacaoAjusteParcial,
        'solicitacao-editar-marcacoes': SolicitacaoEditarMarcacoes,
        'Paginacao': Paginacao,
    },
    created() {       
        this.controlePontoService = new ControlePontoService();
        this.solicitacaoService = new SolicitacaoService();
        this.centroCustoService = new CentroCustoService();
        this.validarPermissoes();
    },
    mounted() {
        this.criarRangeData();
        this.listarCnpjs();
    },
};
</script>

<style lang="scss" scoped>
.p-rowgroup-footer td {
    font-weight: 700;
}

:deep(.p-rowgroup-header) {
    span {
        font-weight: 700;
    }

    .p-row-toggler {
        vertical-align: middle;
        margin-right: 0.25rem;
    }
}
</style>
